/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import VirtualReality from "layouts/virtual-reality";
import RTL from "layouts/rtl";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import Users from "layouts/users";
import Stores from "layouts/stores";
import Integrations from "layouts/integrations";
import Receipts from "layouts/receipts";
import ComingSoon from "layouts/comingsoon";

// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Settings from "examples/Icons/Settings";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import { AnalyticsRounded, CreditCardRounded, DevicesRounded, ForestRounded, HomeRounded, KeyRounded, PeopleRounded, PersonRounded, ReceiptLong, ReceiptRounded, ShopRounded, StoreRounded } from "@mui/icons-material";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <HomeRounded size="12px" />,
    component: <Dashboard />,
    noCollapse: true,
  },
  { type: "title", title: "Your business", key: "business-pages" },
  {
    type: "collapse",
    name: "Receipts",
    key: "receipts",
    route: "/receipts",
    icon: <ReceiptRounded size="12px" />,
    component: <Receipts />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Stores",
    key: "stores",
    route: "/stores",
    icon: <StoreRounded size="12px" />,
    component: <Stores />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Teams",
    key: "teams",
    route: "/teams",
    icon: <PeopleRounded size="12px" />,
    component: <ComingSoon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Integrations",
    key: "integrations",
    route: "/integrations",
    icon: <DevicesRounded size="12px" />,
    component: <Integrations />,
    noCollapse: true,
  },
  { type: "title", title: "Analytics", key: "analytics-pages" },
  {
    type: "collapse",
    name: "Performance",
    key: "performance",
    route: "/performance",
    icon: <AnalyticsRounded size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Environmental",
    key: "environmental",
    route: "/environmental",
    icon: <ForestRounded size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  { type: "title", title: "Account", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <PersonRounded size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    route: "/billing",
    icon: <CreditCardRounded size="12px" />,
    component: <Billing />,
    noCollapse: true,
  },
  { type: "title", title: "Management", key: "manager-pages" },
  {
    type: "collapse",
    name: "Businesses",
    key: "businesses",
    route: "/businesses",
    icon: <StoreRounded size="12px" />,
    component: <Billing />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "API Keys",
    key: "api-keys",
    route: "/api-keys",
    icon: <KeyRounded size="12px" />,
    component: <Billing />,
    noCollapse: true,
  },
];

export default routes;
